import api from './api';

const accessService = {
  async getOverview() {
    const response = await api.get('/access');
    return response.data;
  },

  async grantAccess(dto) {
    const response = await api.post('/access', dto);
    return response.data;
  },

  async updateAccess(professionalId, targetUserId, dto) {
    const response = await api.put(`/access/${professionalId}/${targetUserId}`, dto);
    return response.data;
  },

  async revokeAccess(professionalId, targetUserId) {
    await api.delete(`/access/${professionalId}/${targetUserId}`);
    return null;
  },
};

export default accessService;
